import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addNewCoverMemberSearch',
  pure: false
})

  export class AddNewCoverMemberSearchPipe implements PipeTransform {
  transform(data: any[], searchTerm: string): any[] {
    if (searchTerm) {
      searchTerm = searchTerm.toLowerCase();
      return data.filter(item => {
        return item.membershipNumber.toLowerCase().indexOf(searchTerm) !== -1 || item.name.toLowerCase().indexOf(searchTerm) !== -1;
      });
    } else {
      return data;
    }
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/venue-details/add-new-cover/add-new-cover-member-search.pipe.ts